import { Values } from '@lib/interfaces/form';

/**
 * Checks if any tabs were deleted by comparing original tabs with submitted form values.
 *
 * @param values - Form values containing the submitted tabs array
 * @param originalTabs - Original tabs before editing
 * @returns true if any original tabs are missing in the submitted values
 *
 * @example
 * const original = [{ id: '1' }, { id: '2' }, { id: '3' }];
 * const submitted = { tabs: [{ id: '1' }, { id: '3' }] };
 * hasDeletedTabs(submitted, original); // true (tab '2' was deleted)
 */
export default function hasDeletedTabs(
  values: Values,
  originalTabs: Array<{ id: string }>,
): boolean {
  const submittedTabIds = new Set(
    (values.tabs as Array<{ id?: string }>)
      .map((tab) => tab.id)
      .filter(Boolean),
  );
  const originalTabIds = originalTabs.map((tab) => tab.id);

  // Check if any original tab IDs are missing in submitted values
  return originalTabIds.some((id) => !submittedTabIds.has(id));
}
